import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles, FormControl, Typography } from '@material-ui/core';
import { CloudUploadOutlined, CloudDoneOutlined } from '@material-ui/icons';

import { useTranslation } from 'react-i18next';

const styles = theme => ({
  dropArea: {
    width: '100%',
    borderWidth: 2,
    borderStyle: 'dashed',
    borderColor: theme.palette.primary.main,
    marginTop: 16,
    padding: 16,
    marginBottom: 8,
    textAlign: 'center'
  },
  dragIn: {
    opacity: 0.5
  },
  uploadBtn: {
    fontSize: '4em'
  },
  searchLabel: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    display: 'inline-block'
  },
  uploadedIcon: {
    opacity: 0.7,
    fontSize: '2.5em',
    marginRight: 16,
    verticalAlign: 'middle'
  },
  formControl: {
    position: 'relative',
    width: '100%',
    marginTop: 16,
    marginBottom: 8
  },
  hiddenFileInput: {
    opacity: 0,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }
});

const DragAndDropArea = (props) => {
  const [dragging, setDragging] = useState(false);
  const { classes, accept } = props;
  const dropRef = React.createRef();
  const { t } = useTranslation();

  useEffect(() => {
    const div = dropRef.current;

    div.addEventListener('dragenter', handleDragIn);
    div.addEventListener('dragover', handleDragIn);
    div.addEventListener('dragleave', handleDragOut);
    div.addEventListener('dragend', handleDragOut);
    div.addEventListener('drop', handleDrop);

    return () => {
      div.removeEventListener('dragenter', handleDragIn);
      div.removeEventListener('dragover', handleDragIn);
      div.removeEventListener('dragleave', handleDragOut);
      div.removeEventListener('dragend', handleDragOut);
      div.removeEventListener('drop', handleDrop);
    };
  }, []);

  function handleDragIn (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragging(true);
  }

  function handleDragOut (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
  }

  function handleDrop (e) {
    e.preventDefault();
    e.stopPropagation();

    let file;
    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      file = e.dataTransfer.files[0];
      document.getElementById('file-upload').files = e.dataTransfer.files;
    } else {
      file = e.target.files[0];
    }

    setDragging(false);
    document.getElementById('filename').innerHTML = file.name;
    document.getElementById('uploaded-file').style.display = 'block';
    props.setContent(file);
  }

  return (
    <div style={{ width: '100%' }}>
      <FormControl className={classes.formControl}>
        <input
          type='file'
          name='file'
          accept={accept || '*'}
          className={classes.hiddenFileInput}
          id='file-upload'
          onChange={handleDrop}
          required
        />
        <div id='uploaded-file' style={{ display: 'none' }}>
          <CloudDoneOutlined className={classes.uploadedIcon} />
          <span id='filename' />
        </div>
        <div
          id='drop-area'
          className={classNames(classes.dropArea, {
            [classes.dragIn]: dragging
          })}
          ref={dropRef}
        >
          <CloudUploadOutlined className={classes.uploadBtn} color='primary' />
          <Typography>{t('dragAndDrop:dragFile')}</Typography>
          <Typography>{t('dragAndDrop:o')}</Typography>
          <label htmlFor='file-upload' className={classes.searchLabel}>{t('dragAndDrop:lookForOne')}</label>
        </div>
      </FormControl>
    </div>
  );
};

DragAndDropArea.propTypes = {
  classes: PropTypes.object.isRequired,
  accept: PropTypes.array,
  setContent: PropTypes.func.isRequired
};

export default withStyles(styles, { withTheme: true })(DragAndDropArea);
